import { fetchConfig, debounce, trapFocus, removeTrapFocus, onKeyUpEscape } from './global';

export class Cart extends HTMLElement {

  constructor() {

    super();

    if(!('basket' in window)){

      window.basket = {};
      window.basket.synced = false;
      window.basket.lines = [];
      window.basket.note = '';
      window.basket.discounts = [];
      window.basket.totals = [];
      window.basket.quantity = 0;
      window.basket.checkoutUrl = false;

    }

    this.fetchContents();

  }

  fetchContents(force = false){

    let vm = this;

    return new Promise((resolve, reject) => {
      
      if(window.basket.synced && !force){

        resolve();

      }else{

        const config = fetchConfig('javascript');
        config.method = 'GET';

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          //console.log('setting again');

          window.basket.synced = true, 
          window.basket.lines = response.lines;
          window.basket.note = response.note;
          window.basket.discountAllocations = response.discountAllocations;
          window.basket.discounts = response.discountCodes;
          window.basket.cost = response.cost;
          window.basket.quantity = response.totalQuantity;
          window.basket.checkoutUrl = response.checkoutUrl;

          if (window.OptiMonk || window.OptiMonkEmbedded ) {
            console.log('[OPTIMONK] present');
            var OM = window.OptiMonk || window.OptiMonkEmbedded;
            if(OM.Visitor){
              console.log('[OPTIMONK] active campaign');
              var adapter = OM.Visitor.createAdapter();
              adapter.Cart.clear();
              for(let i = 0; i < response.lines.edges.length; i++){
                let product = response.lines.edges[i].node;
                let merchandise = product.merchandise.id.replace('gid://shopify/ProductVariant/', '').replace('gid://shopify/Product/', '')
                adapter.Cart.add(merchandise, { quantity: product.quantity, price: ((parseFloat(product.cost.subtotalAmount.amount)*100)/product.quantity) });
              }
            }else{
              console.log('[OPTIMONK] no active campaign');
            }
          }else{
            console.log('[OPTIMONK] not present');
          }

          resolve()

        });

      }

    });

  }

  formatCurrency(amount){

    let GBP = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: amount.currencyCode,
    });

    return GBP.format(amount.amount);

  }

}

export class CartRemoveButton extends Cart {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.productId, this.dataset.lineId, 0, this.dataset.sellingPlanId);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartNote extends Cart {
  constructor() {
    super();

    this.textarea = this.querySelector('textarea');

    let self = this;

    this.fetchContents().then(() => {
      self.textarea.value = window.basket.note;
    })

    this.textarea.addEventListener('keyup', debounce((event) => {
      event.target.classList.remove('saved');
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_note_url}`, {...fetchConfig('javascript'), ...{ body }});
      event.target.classList.add('saved');
      setTimeout(function(){
        event.target.classList.remove('saved');
      }, 2000)
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

class CartCoupon extends Cart {
  constructor() {
    super();

    this.couponInput = this.querySelector('input');
    this.couponButton = this.querySelector('button');

    let self = this;

    this.couponButton.addEventListener('click', function(){
      self.couponButton.setAttribute('disabled', 'disabled');
      const body = JSON.stringify({ discount: self.couponInput.value });
      fetch(`${routes.cart_discount_url}`, {...fetchConfig('javascript'), ...{ body }})
      .then((response) => {
        if (!response.ok) {
          self.couponButton.insertAdjacentHTML("afterend", "<p class='error'>Sorry, that code doesn't seem to be valid.</p>")
        }else{
          //console.log('cart refreshing...');
          window.dispatchEvent(new Event("cartrefresh"));
        }
        self.couponButton.removeAttribute('disabled');
      });
    });
  }
}

customElements.define('cart-coupon', CartCoupon);

export class CartItems extends Cart {
  constructor() {

    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => this.onChange(event), 300);

    //this.addEventListener('change', this.debouncedOnChange.bind(this));

  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(id, lineId, quantity, selling_plan) {

    //this.enableLoading(line);

    const body = JSON.stringify({
      id,
      lineId,
      quantity,
      selling_plan
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        //console.log('cart refreshing...');
        window.dispatchEvent(new Event("cartrefresh"));
      }).catch(() => {
        //this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        //this.disableLoading();
      });
  }

  // updateLiveRegions(line, itemCount) {
  //   if (this.currentItemCount === itemCount) {
  //     const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
  //     const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
  //     lineItemError
  //       .querySelector('.cart-item__error-text')
  //       .innerHTML = window.cartStrings.quantityError.replace(
  //         '[quantity]',
  //         quantityElement.value
  //       );
  //   }

  //   this.currentItemCount = itemCount;
  //   this.lineItemStatusElement.setAttribute('aria-hidden', true);

  //   const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
  //   cartStatus.setAttribute('aria-hidden', false);

  //   setTimeout(() => {
  //     cartStatus.setAttribute('aria-hidden', true);
  //   }, 1000);
  // }

  // getSectionInnerHTML(html, selector) {
  //   return new DOMParser()
  //     .parseFromString(html, 'text/html')
  //     .querySelector(selector).innerHTML;
  // }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

export class CartDrawerItems extends CartItems {

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

export class CartDrawer extends Cart {
  constructor() {
    super();
    
    this.templates = {};
    this.templates.empty = this.querySelector('template#cart-empty').content;
    this.templates.header = this.querySelector('template#cart-header').content;
    this.templates.items = this.querySelector('template#cart-items').content;
    this.templates.lineitem = this.querySelector('template#cart-lineitem').content;
    this.templates.footer = this.querySelector('template#cart-footer').content;

    this.cartDrawer = this.querySelector('.cart-drawer')
    this.cartDrawerInner = this.cartDrawer.querySelector('.drawer__inner')

    this.cartLink = document.querySelector('#cart-icon-bubble');
    this.cartLinkCount = this.cartLink.querySelector('.cart-count-bubble');
    this.cartLinkCountSpan = this.cartLinkCount.querySelector('span[aria-hidden="true"]');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.renderContents();

    let vm = this;

    window.addEventListener("cartrefresh", function(){
      //console.log('heard cartrefresh');
      vm.renderContents(true);
    })

    window.addEventListener("cartopen", function(){
      vm.open(false);
    })

    window.addEventListener("cartclose", function(){
      vm.close();
    })

  }

  setHeaderCartIconAccessibility() {
    this.cartLink.setAttribute('role', 'button');
    this.cartLink.setAttribute('aria-haspopup', 'dialog');
    this.cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(this.cartLink)
    });
    this.cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(this.cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(force = false) {

    //console.log('renderContents called')

    let self = this;

    var scrollPosition;

    if(this.cartDrawerInner.querySelector('cart-drawer-items')){
      scrollPosition = this.cartDrawerInner.querySelector('cart-drawer-items').scrollTop;
    }else{
      scrollPosition = false;
    }

    this.fetchContents(force).then(() => {

      self.cartDrawerInner.querySelectorAll('.from-template').forEach((elem) => elem.parentNode.removeChild(elem));

      if(
        'basket' in window &&
        'lines' in window.basket &&
        window.basket.lines !== undefined &&
        'edges' in window.basket.lines &&
        window.basket.lines.edges.length > 0
      ){

        self.classList.remove('is-empty');

        var header = self.templates.header.cloneNode(true);
        self.cartDrawerInner.appendChild(header);

        var items = self.templates.items.cloneNode(true);
        self.cartDrawerInner.appendChild(items);

        for( var i = 0; i < window.basket.lines.edges.length; i++){

          let line_item_data = window.basket.lines.edges[i].node;
          let line_item = self.templates.lineitem.cloneNode(true);

          line_item.querySelector('quantity-input').dataset.productId = line_item_data.merchandise.id;
          line_item.querySelector('quantity-input').dataset.lineId = line_item_data.id;
          line_item.querySelector('cart-remove-button').dataset.productId = line_item_data.merchandise.id;
          line_item.querySelector('cart-remove-button').dataset.lineId = line_item_data.id;
          

          line_item.querySelector('.quantity__input').value = line_item_data.quantity;
          line_item.querySelectorAll('.cart-item__url').forEach((elem) => elem.href = `/products/${line_item_data.merchandise.product.handle}`);
          line_item.querySelectorAll('.cart-item__image').forEach((elem) => {
            elem.src = line_item_data.merchandise.product.images.edges[0].node.url;
            elem.alt = line_item_data.merchandise.product.images.edges[0].node.altText;
            elem.height = Math.ceil(150 / (line_item_data.merchandise.product.images.edges[0].node.width / line_item_data.merchandise.product.images.edges[0].node.width))
          });
          line_item.querySelectorAll('.cart-item__name').forEach((elem) => elem.innerText = line_item_data.merchandise.product.title)

          if(line_item_data.cost.subtotalAmount.amount != line_item_data.cost.totalAmount.amount){

            line_item.querySelector('.cart-item__discounted-prices').classList.remove('d-none');
            line_item.querySelector('.cart-item__regular-prices').classList.add('d-none');
            line_item.querySelector('.cart-item__old-price').innerText = self.formatCurrency(line_item_data.cost.subtotalAmount);
            line_item.querySelector('.cart-item__final-price').innerText = self.formatCurrency(line_item_data.cost.totalAmount);

          }else{

            line_item.querySelector('.cart-item__discounted-prices').classList.add('d-none');
            line_item.querySelector('.cart-item__regular-prices').classList.remove('d-none');
            line_item.querySelector('.cart-item__regular-prices').innerText = self.formatCurrency(line_item_data.cost.totalAmount);

          }

          if('sellingPlanAllocation' in line_item_data && line_item_data.sellingPlanAllocation != null && 'sellingPlan' in line_item_data.sellingPlanAllocation && line_item_data.sellingPlanAllocation.sellingPlan.name){
            line_item.querySelector('.cart-item__subscription-name').innerText = `Delivered every ${line_item_data.sellingPlanAllocation.sellingPlan.name.toLowerCase().replace('ly','')}`;
            line_item.querySelector('.cart-item__subscription-name').classList.remove('d-none');
          }else{
            line_item.querySelector('.cart-item__subscription-name').innerText = '';
            line_item.querySelector('.cart-item__subscription-name').classList.add('d-none');
          }

          var optionTemplate = line_item.querySelector('.cart-item__subscription-name')

          if('merchandise' in line_item_data && 'selectedOptions'in line_item_data.merchandise && line_item_data.merchandise.selectedOptions.length > 0){

            for(const option of line_item_data.merchandise.selectedOptions){

              //console.log(option);

              if(option.value != "Default Title"){
            
                let optionHTML = optionTemplate.cloneNode(true);
                optionHTML.classList.remove('cart-item__subscription-name');
                optionHTML.classList.remove('d-none');
                optionHTML.classList.add('cart-item__option-name');
                optionHTML.innerText = `${option.name}: ${option.value}`;
                //console.log(optionHTML);

                optionTemplate.parentNode.insertBefore(optionHTML, optionTemplate);

              }

            }
          
          }

          line_item.querySelector('quantity-input input').addEventListener('change', function(event){
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            cartItems.updateQuantity(this.closest('quantity-input').dataset.productId, this.closest('quantity-input').dataset.lineId, this.value, this.closest('quantity-input').dataset.sellingPlanId);
          });

          self.cartDrawerInner.querySelector('tbody').appendChild(line_item);

          //console.log(line_item);

        }

        var footer = self.templates.footer.cloneNode(true);

        let applicableDiscounts = window.basket.discounts.filter(x => x.applicable == true);

        if(window.basket.cost.subtotalAmount.amount < window.basket.cost.totalAmount.amount){
          footer.querySelector('.totals.totals-subtotal').classList.remove('d-none');
          footer.querySelector('.totals.totals-subtotal .totals__subtotal-value').innerText = self.formatCurrency(window.basket.cost.subtotalAmount)
          footer.querySelector('.totals.totals-shipping').classList.remove('d-none');
          footer.querySelector('.totals.totals-shipping .totals__shipping-value').innerText = self.formatCurrency({ amount: window.basket.cost.totalAmount.amount - window.basket.cost.subtotalAmount.amount, currencyCode: 'GBP'})
        }else if(window.basket.cost.subtotalAmount.amount > window.basket.cost.totalAmount.amount){
          footer.querySelector('.totals.totals-subtotal').classList.remove('d-none');
          footer.querySelector('.totals.totals-subtotal .totals__subtotal-value').innerText = self.formatCurrency(window.basket.cost.subtotalAmount)
          footer.querySelector('.totals.totals-discounts').classList.remove('d-none');
          footer.querySelector('.totals.totals-discounts .totals__discounts-value').innerText = self.formatCurrency({ amount: window.basket.cost.totalAmount.amount - window.basket.cost.subtotalAmount.amount, currencyCode: 'GBP'})
        }

        let appliedDiscountsDisplay = footer.querySelector('.applied-discounts');

        if(applicableDiscounts.length > 0){

          applicableDiscounts.forEach((discount) => {

            let a = document.createElement('a');
            a.href = '#';
            a.innerText = discount.code;

            if(window.settings.codes.split(',').includes(discount.code)){
              a.dataset.popover = "We've automatically applied this discount because you met the criteria for it.";
            }

            let button = document.createElement('button');
            button.type = 'button';
            button.dataset.discount = discount.code;
            button.innerHTML = '<svg viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M15.1 2.3L13.7.9 8 6.6 2.3.9.9 2.3 6.6 8 .9 13.7l1.4 1.4L8 9.4l5.7 5.7 1.4-1.4L9.4 8"></path></svg>';

            a.appendChild(button);

            appliedDiscountsDisplay.appendChild(a);

            button.addEventListener("click", function(event){
              let element;
              if(event.target.tagName != 'BUTTON'){
                element = event.target.closest('button');
              }else{
                element = event.target;
              }
              //console.log('element', element);
              let code = element.dataset.discount;
              self.removeDiscount(code);
            });

          })

        }else{

          appliedDiscountsDisplay.innerHTML = '&nbsp;';

        }

        footer.querySelector('.totals.totals-total .totals__total-value').innerText = self.formatCurrency(window.basket.cost.totalAmount)

        self.cartDrawerInner.appendChild(footer);

      }else{

        self.classList.add('is-empty');

        var emptyMessage = self.templates.empty.cloneNode(true); 
        self.cartDrawerInner.appendChild(emptyMessage);
        
      }

      if(scrollPosition){
        self.cartDrawerInner.querySelector('cart-drawer-items').scrollTop = scrollPosition;
      }

      if('checkoutUrl' in window.basket && window.basket.checkoutUrl !== undefined && self.cartDrawerInner.querySelector('#CartDrawer-Checkout')){

        self.cartDrawerInner.querySelector('#CartDrawer-Checkout').removeAttribute('disabled');
        self.cartDrawerInner.querySelector('#CartDrawer-Checkout').addEventListener("click", function(){
          self.checkout()
        });

      }

      if('quantity' in window.basket && window.basket.quantity > 0){

        self.cartLinkCount.classList.remove('d-none');
        self.cartLinkCountSpan.innerText = window.basket.quantity;

      }else{

        self.cartLinkCount.classList.add('d-none');
        self.cartLinkCountSpan.innerText = '';

      }

    });

  }

  removeDiscount(code){
    console.log('REMOVE', self, event);

    const body = JSON.stringify({ discount: code, action: 'delete' });
    let config = {...fetchConfig('javascript'), ...{ body }}
    fetch(`${routes.cart_discount_url}`, config)
    .then((response) => {
      console.log('cart refreshing...');
      window.dispatchEvent(new Event("cartrefresh"));
    })

  }

  checkout(){
    
    let config = {...fetchConfig('javascript')}
    fetch(`${routes.cart_checkout_url}`, config)
    .then((response) => {
      window.location.href = window.basket.checkoutUrl;
    })

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  createNode(html){
    return new DOMParser()
      .parseFromString(html, 'text/html').body.firstElementChild;
  }

  createTR(html){
    return new DOMParser()
      .parseFromString(html, 'text/xml');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);